import SecureRandom from "@/util/SecureRandom";

export default class FileAES {
    private key: CryptoKey;

    public static readonly ivLength: number = 12; // Bytes not Bits (12 for AES-GCM, 16 for AES-CBC/CTR)
    public static readonly keyLength: number = 32; // Bytes not Bits!
    public static readonly opMode: string = 'AES-GCM';

    constructor(key: CryptoKey) {
        this.key = key;
    }

    public static generateKey(): Promise<CryptoKey> {
        return crypto.subtle.generateKey(
            {
                name: FileAES.opMode,
                length: FileAES.keyLength * 8,
            },
            true,
            ['encrypt', 'decrypt'],
        );
    }

    public encryptChunk(plainBytes: ArrayBuffer, iv: Uint8Array): Promise<ArrayBuffer> {
        return crypto.subtle.encrypt({ name: FileAES.opMode, iv, tagLength: 128 }, this.key, plainBytes);
    }

    public decryptChunk(encryptedBytes: ArrayBuffer, iv: Uint8Array): Promise<ArrayBuffer> {
        return crypto.subtle.decrypt({ name: FileAES.opMode, iv, tagLength: 128 }, this.key, encryptedBytes);
    }

}
